<div class="ir-plugin th-plugin" *ngIf="plugin">
  <div class="ir-line ir-plugin-title" [ngClass]="{ 'ir-plugin-gray': showBreadcrumbs }">
    <div class="ir-line--right">
      <div
        class="ir-btn"
        *ngIf="showHelpButton"
        [ngClass]="showPluginHelp ? 'th-btn-action' : 'th-btn-normal'"
        (click)="showHidePluginHelp()"
      >
        <span>?</span>
      </div>
      <div
        class="ir-btn"
        [ngClass]="showValidations ? 'th-btn-action' : 'th-btn-normal'"
        [permissions]="[['visible', 'inspection.offline.edit', inspection]]"
        [routerLink]="getEditRoute()"
      >
        <span>{{ (showValidations ? 'common.open' : 'common.edit') | translate }}</span>
      </div>
    </div>
    <div class="ir-line-content">
      <span>
        {{ showBreadcrumbs ? plugin.inspection.name + ' / ' : '' }}
        {{ showBreadcrumbs && plugin.point?.name ? plugin.point?.name + ' / ' : '' }}
        {{ 'plugins.bobst-contact.name' | translate }}</span
      >
    </div>
  </div>
  <div class="ir-line ir-plugin-validation" *ngIf="showValidations">
    <table class="ir-plugin-table">
      <tr class="th-plugin-line--content ir-plugin-gray">
        <td class="th-plugin-line--data" >
          <div *ngFor="let message of messages"><span  innerHtml="{{ message | translate: { value: plugin } }}"></span>
      </div>  </td>
      </tr>
    </table>
  </div>
  <div class="ir-plugin-content ir-plugin-info th-plugin-info" *ngIf="showContent">
    <p class="ir-plugin-instruction" *ngIf="showPluginHelp">
      <span innerHtml="{{ plugin?.description }}"></span>
    </p>
    <div *ngIf="technicien">
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span
              ><strong>{{ 'plugins.bobst-contact.technician-name' | translate }}</strong></span
            >
          </p>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span>{{ technicien.name }}</span>
          </p>
        </div>
      </div>
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span
              ><strong>{{ 'plugins.bobst-contact.technician-telephone' | translate }}</strong></span
            >
          </p>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span>{{ technicien.phone }}</span>
          </p>
        </div>
      </div>
      <div class="ir-row">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span
              ><strong>{{ 'plugins.bobst-contact.technician-email' | translate }}</strong></span
            >
          </p>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span>{{ technicien.email }}</span>
          </p>
        </div>
      </div>
    </div>
    <div>
      <div class="ir-row" *ngIf="plugin?.config?.RegionalServiceManagerName">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span
              ><strong>{{ 'plugins.bobst-contact.service-manager-name' | translate }}</strong></span
            >
          </p>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span>{{ plugin?.config?.RegionalServiceManagerName }}</span>
          </p>
        </div>
      </div>
      <div class="ir-row" *ngIf="plugin?.config?.RegionalServiceManagerTel">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span
              ><strong>{{ 'plugins.bobst-contact.service-manager-telephone' | translate }}</strong></span
            >
          </p>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span>{{ plugin?.config?.RegionalServiceManagerTel }}</span>
          </p>
        </div>
      </div>
      <div class="ir-row" *ngIf="plugin?.config?.RegionalServiceManagerEmail">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span
              ><strong>{{ 'plugins.bobst-contact.service-manager-email' | translate }}</strong></span
            >
          </p>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span>{{ plugin?.config?.RegionalServiceManagerEmail }}</span>
          </p>
        </div>
      </div>
      <div class="ir-row" *ngIf="plugin?.config?.LocalOfficeTel">
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span
              ><strong>{{ 'plugins.bobst-contact.bobst-local-telephone' | translate }}</strong></span
            >
          </p>
        </div>
        <div class="ir-cell-tin6 ir-cell-sma6 ir-cell-mid6 ir-cell-lar6">
          <p>
            <span>{{ plugin?.config?.LocalOfficeTel }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</div>
